export default "__VITE_ASSET__BVhNyINF__"